// https://www.smashingmagazine.com/2022/09/inline-validation-web-forms-ux/#1-show-errors-immediately-if-issues-are-severe

export class InlineError extends Error {
  protected constructor(
    public readonly message: string,
    public readonly options: {
      shouldPunishWhileEditing: boolean;
      shouldPunishAfterEditing: boolean;
    }
  ) {
    super(message);
  }

  static assert$PunishBeforeSubmitting(
    condition: unknown,
    message: string
  ): asserts condition {
    if (!condition) {
      throw new this(message, {
        shouldPunishWhileEditing: false,
        shouldPunishAfterEditing: false,
      });
    }
  }

  static assert$PunishAfterEditing(
    condition: unknown,
    message: string
  ): asserts condition {
    if (!condition) {
      throw new this(message, {
        shouldPunishWhileEditing: false,
        shouldPunishAfterEditing: true,
      });
    }
  }

  static assert$PunishWhileEditing(
    condition: unknown,
    message: string
  ): asserts condition {
    if (!condition) {
      throw new this(message, {
        shouldPunishWhileEditing: true,
        shouldPunishAfterEditing: true,
      });
    }
  }
}

/** Low severity: only when input is blank */
export class InlineError$PunishBeforeSubmitting extends InlineError {
  constructor(message: string) {
    super(message, {
      shouldPunishWhileEditing: false,
      shouldPunishAfterEditing: false,
    });
  }

  static assert(condition: unknown, message: string): asserts condition {
    if (!condition) {
      throw new this(message);
    }
  }
}

/**
 * Mid severity: when input is invalid but user should be on the right track
 *
 * For example: "john" is not a valid email, but user might be typing
 * "john@doe.com", which is a valid email.
 */
export class InlineError$PunishAfterEditing extends InlineError {
  constructor(message: string) {
    super(message, {
      shouldPunishWhileEditing: false,
      shouldPunishAfterEditing: true,
    });
  }

  static assert(condition: unknown, message: string): asserts condition {
    if (!condition) {
      throw new this(message);
    }
  }
}

/** High severity: when input cannot be right
 *
 * For example: "john" is not a valid number, and there are no reasons
 * why user should input it.
 */
export class InlineError$PunishWhileEditing extends InlineError {
  constructor(message: string) {
    super(message, {
      shouldPunishWhileEditing: true,
      shouldPunishAfterEditing: true,
    });
  }

  static assert(condition: unknown, message: string): asserts condition {
    if (!condition) {
      throw new this(message);
    }
  }
}
